import { Color } from '../../src/js/three.module.js';
/**
 * rgb color or somethign eelse as r
 * @param {number} r 
 * @param {number} g 
 * @param {number} b
 */
export function createHemisphereColors( r,g,b ) {

    // Convert to HSL to easily modify lightness
    const color = new Color( r, g, b );

    /** @type {{ h: number, s: number, l: number }} */
    let hsl = {};
    color.getHSL(hsl);
    
    // Sky color is the input color
    const skyColor = color;
    
    // Ground color is complementary (opposite hue)
    const groundColor = new THREE.Color().setHSL(
        (hsl.h + 0.5) % 1, // Opposite hue
        hsl.s,
        hsl.l * 0.7      // Slightly darker
    );

    return { skyColor, groundColor };
}
/**
 * Creates a darker version of the input color for hemisphere ground
 * @param {number} r 
 * @param {number} g 
 * @param {number} b
 * @returns {Color}
 */
export function createHemisphereGroundColor(r, g, b) {
    // Convert to HSL to easily modify lightness
    const color = new Color(r, g, b);

    /** @type {{ h: number, s: number, l: number }} */
    let hsl = {};
    color.getHSL(hsl);
    
    // Ground color is just darker version of the sky color
    const groundColor = new THREE.Color().setHSL(
        hsl.h,           // Same hue
        hsl.s,           // Same saturation
        hsl.l * 0.8      // 80% darker
    );

    return groundColor;
}